// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1OplC","rootSmall":"AddTileButton_rootSmall__1fCNO"};